import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { initTelemetry } from './lib/telemetry';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Boot telemetry in the background. It's safe to call before auth completes —
// if there's no token yet, initTelemetry quietly no-ops and useAuth.login will
// re-invoke it after a successful login.
void initTelemetry();
